import React,{Component} from 'react';
import NumberFormat from 'react-number-format';

class TotalItem extends Component{
	render(){
		return (
			<div className="row">
				<label className={"col-sm-"+ this.props.size.lSize +" col-form-label"}>{this.props.label}</label>
				<div className={"col-sm-"+ this.props.size.dSize}>
					<div className="form-group">
						<NumberFormat value={this.props.value}
                            		  allowNegative={true}
									  isNumericString={true}
									  decimalScale={2}
									  fixedDecimalScale={true}
									  thousandSeparator={'.'}
									  decimalSeparator={','}
									  disabled={this.props.disabled === undefined ? true : this.props.disabled}
                                      isAllowed={values => {
                                          return (values.value === "" ? false : true);
                                      }}
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.props.changeChargeValue && this.props.changeChargeValue({name: this.props.name,value:e.value})}
                                      suffix={this.props.suffix}
									  displayType={"input"}
									  className="form-control"/>
					</div>
				</div>
			</div>
		);
	}
}

export default TotalItem;